const L1_BASE_GAS_BUDGET = 10000000n;
const L2_FROM_L1_GAS_BUDGET = 1000000n;
export {
  L1_BASE_GAS_BUDGET,
  L2_FROM_L1_GAS_BUDGET
};
//# sourceMappingURL=constants.js.map
